var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shield-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg shield",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,6.17,16.4.14a1.17,1.17,0,0,0-1.12,0l-11,6a1.18,1.18,0,0,0-.61,1v8.54A16.93,16.93,0,0,0,13.81,31.24l1.52.66a1.15,1.15,0,0,0,.94,0L18,31.16A16.89,16.89,0,0,0,28.34,15.59V7.21A1.16,1.16,0,0,0,27.71,6.17ZM26,15.59A14.54,14.54,0,0,1,17.07,29h0l-1.25.54-1.06-.46A14.56,14.56,0,0,1,6,15.75V7.9l9.84-5.39L26,7.91v7.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.08,12.85a1.17,1.17,0,0,0-1.65-.17l-6,4.92L12.15,15a1.17,1.17,0,1,0-1.78,1.53l3,3.48a1.18,1.18,0,0,0,.9.42,1.17,1.17,0,0,0,.74-.27l6.93-5.64A1.17,1.17,0,0,0,22.08,12.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.841bd163d55b0ddf654770cdae6106ca.svg";
export { ForwardRef as ReactComponent };